<div class="modal-header">
  <h5 class="modal-title">{{ title | translate }}</h5>
  <button type="button" class="close" (click)="dismiss()">
    <span>&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="border rounded p-1" style="min-height: 100px">
    <app-core-image-list
      [entityType]="entityType"
      [entityId]="entityId"
      [editable]="true"
    ></app-core-image-list>
    <app-core-image-upload
      [multiple]="true"
      [showSaveHint]="true"
      (imagesUploaded)="onImagesUploaded($event)"
    ></app-core-image-upload>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-light" (click)="dismiss()">
    {{ "navigations.close" | translate }}
  </button>
  <button
    type="button"
    class="btn btn-sm btn-success"
    (click)="upload()"
    [disabled]="uploadComp?.isUploading"
  >
    <i *ngIf="uploadComp?.isUploading" class="la la-spinner la-spin"></i>
    {{ "core_image_upload.upload" | translate }}
  </button>
</div>
